<template>
  <v-alert :value="value" type="warning">
    Strict data validation is enabled for this column. This means that every row inside the raw data file must have a
    non-empty value to pass validation.
  </v-alert>
</template>
<script>
  export default {
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
  }

</script>
